import { tns } from 'tiny-slider/src/tiny-slider'

const carouselContainerElementSelector = '.js-carousel-container'
const carouselPrevSlideButtonSelector = '.js-carousel-prev'
const carouselNextSlideButtonSelector = '.js-carousel-next'

if (!window.carousels) {
  window.carousels = []
}

export function renderCarousel (carouselElement, { carouselOptions, distanceToLoad }) {
  const carouselContainerElement = carouselElement.querySelector(carouselContainerElementSelector)
  const nextElement = carouselElement.querySelector(carouselNextSlideButtonSelector)
  const prevElement = carouselElement.querySelector(carouselPrevSlideButtonSelector)

  carouselElement.style.display = ''

  const defaultCarouselOptions = getCarouselSettings({
    carouselElement: carouselContainerElement,
    nextElement: nextElement,
    prevElement: prevElement
  })

  const slider = tns({...defaultCarouselOptions, ...carouselOptions}) // eslint-disable-line

  return slider
}

function getCarouselSettings ({ carouselElement, nextElement, prevElement }) {
  return {
    container: carouselElement,
    speed: 600,
    lazyload: false,
    loop: false,
    items: 1,
    slideBy: 'page',
    nav: false,
    navPosition: 'bottom',
    prevButton: prevElement,
    nextButton: nextElement,
    controlsPosition: 'bottom',
    preventScrollOnTouch: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/modules/carousel.js